import 'babel-polyfill'; // for IE 11
import Vue from 'vue';
import VTooltip from 'v-tooltip'; //툴팁 추가 20191015 kjw
import VueAxios from 'vue-axios';
import VeeValidate from 'vee-validate';
import request from '@/lib/request';
import { DatePicker, TimeSelect, Input, Tag, Button, Dialog } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import App from './App.vue';
import router from './router';
import store from './store';
import accounting from 'accounting';
import numeral from 'numeral';

import 'vue-awesome/icons/times-rectangle';
import 'vue-awesome/icons/arrows-v';
import 'vue-awesome/icons/camera';

import VueTimeago from 'vue-timeago';
import VueTimeagoLocale from 'vue-timeago/locales/en-US.json';

import Icon from 'vue-awesome/components/Icon';

import './assets/reset.css'; // 퍼블리싱에서 작업한 css for Global
import './assets/css/mstyle.css'; // 모바일 전용 20190523 by sim

import moment from 'moment-timezone';


// import cors from 'cors';

import VueImgOrientationChanger from 'vue-img-orientation-changer';

import Viewer from 'v-viewer'   //이미지뷰어 추가 20200211 kjw
import 'viewerjs/dist/viewer.css';   //이미지뷰어 추가 20200211 kjw

import VueLogger from 'vuejs-logger'; // 로그적용 20200404 kjw
// eslint-disable-next-line no-undef
const isProduction = process.env.NODE_ENV === 'production';
// const isTesting = process.env.NODE_ENV === 'testing';

const v_options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=no'
  ], 
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    // 'https://unpkg.com/pickle-css/css/pickle.css',
    './printstyle.css'
    // `${basePath}/myPrint.css`
    // 'size: 21cm 29.7cm',
    // 'margin: 30mm 45mm 30mm 45mm;
     /* change the margins as you want them to be. */
  ]
};

import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper, v_options);
// Vue.use(VueHtmlToPaper);
 
const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    // logLevel : isTesting ? 'warn' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, options);

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

// 로그 처리 kjw
Sentry.init({
  // dsn: 'https://6a98bd4e6e41470796c0ed4779103909@o391877.ingest.sentry.io/5238691',  // admin - real 
  // dsn: 'https://ebe29117d77c4a1497360add5c9d76da@o394266.ingest.sentry.io/5244180',  // wany - test
  dsn: 'https://c0e069b3673640d182a9098a65851e26@o394266.ingest.sentry.io/5244174', // wany - dev(local)
  integrations: [new VueIntegration({Vue, attachProps: true})],
});

// import VueMask from 'v-mask'; //input masking 20200318 kjw

// configure language (importing Element on demand)
locale.use(lang);

Vue.use(VTooltip); //툴팁 추가 20191015 kjw

Vue.use(VueAxios, request);
Vue.use(VeeValidate);

Vue.use(Tag);
Vue.use(Button);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(Input);
Vue.use(Dialog);

Vue.use(VueTimeago, {
  name: 'timeago', // component name, `timeago` by default
  locale: 'en-US',
  locales: {
    // you will need json-loader in webpack 1
    'en-US': VueTimeagoLocale
  }
});

Vue.use(VueImgOrientationChanger);
Vue.use(Viewer);
// Vue.use(VueMask);

// Vue.use(cors());


Vue.filter('dollars', function (money) {
  return accounting.formatMoney(money)
});

Vue.filter('date', function (date, locale) {
  if (date === undefined) return '' // 아에 변수가 없는경우
  moment.locale(locale)
  var date_mom = moment(date)
  if (date_mom.isValid()) {
    return date_mom.format('LLLL')
  } else {
    return '(정보없음)' // null 인경우
  }
});

Vue.filter('date_format', function (date_str, format_string) {
  if (date_str === undefined) return '' // 아에 변수가 없는경우
  moment.locale('ko')
  var date_mom = moment(date_str)
    if (date_mom.isValid()) {
      return date_mom.format(format_string)
    } else {
      return '(정보없음)' // null 인경우
    }
});

Vue.filter('price_format', function (price) {
  if(price) {
    return numeral(price).format('0,0');
  } else {
    return 0;
  }
});

Vue.filter('phone_format', function (phone) {
  if(phone) {
    if(phone.length==11)
      return phone.replace(/[^0-9]/g, '')
                  .replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    else if (phone.length==10)
      return phone.replace(/[^0-9]/g, '')
                  .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    else if (phone.length==9)
      return phone.replace(/[^0-9]/g, '')
                  .replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
    else
      return phone;    
  } else {
    return '';
  }
        
});

Vue.filter('personal_no_format', function (personal_no) {
  if(personal_no) {
    if(personal_no.length==13)
      return personal_no.replace(/[^0-9]/g, '')
              .replace(/(\d{6})(\d{7})/, '$1-$2');
    else 
    return personal_no;
  } else {
    return '';
  }
});

//T또는 공백으로 온 날짜 시간을 잘라서 날짜만 보여준다
Vue.filter('date_split_format', function (date) {
  if(date) {
    if(date.indexOf('T') != -1) {
      return date.split('T')[0];  
    }else{
      return date.split(' ')[0];  
    }
  } else {
    return '';
  }
});

// globally (in your main .js file)
Vue.component('icon', Icon);

Vue.config.productionTip = false;

// let MyPlugin = {}
// MyPlugin.install = function (Vue, options) {
//   Vue.hahaha = function () {
//
//   }
// }
//

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
